import { render } from "./PublicPuzzlesView.vue?vue&type=template&id=d4ad7280&scoped=true"
import script from "./PublicPuzzlesView.vue?vue&type=script&lang=js"
export * from "./PublicPuzzlesView.vue?vue&type=script&lang=js"

import "./PublicPuzzlesView.vue?vue&type=style&index=0&id=d4ad7280&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4ad7280"]])

export default __exports__